import { Link, useNavigate } from "@tanstack/react-router";
import { useState } from "react";
import { signIn, signUp } from "../lib/auth-client";

export function SignupPage() {
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    if (password.length < 8) return setError("Password must be at least 8 characters.");
    setBusy(true);
    // On success, Better Auth's user.create hook auto-creates a personal org.
    const { error } = await signUp.email({ name, email, password });
    setBusy(false);
    if (error) return setError(error.message ?? "Could not create account.");
    navigate({ to: "/app" });
  }

  return (
    <div className="auth-wrap">
      <div className="auth-card">
        <div className="auth-brand">
          Founder<span>Deck</span>
        </div>
        <div className="auth-sub">Create your workspace — it takes a few seconds.</div>

        {error && <div className="form-err">{error}</div>}

        <form onSubmit={onSubmit}>
          <div className="field">
            <label htmlFor="name">Name</label>
            <input
              id="name"
              type="text"
              autoComplete="name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />
          </div>
          <div className="field">
            <label htmlFor="email">Email</label>
            <input
              id="email"
              type="email"
              autoComplete="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div className="field">
            <label htmlFor="password">Password</label>
            <input
              id="password"
              type="password"
              autoComplete="new-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <button className="btn" type="submit" disabled={busy}>
            {busy ? "Creating account…" : "Create account"}
          </button>
        </form>

        <div className="divider">or</div>
        <button
          className="btn-ghost"
          type="button"
          onClick={() => signIn.social({ provider: "google", callbackURL: "/app" })}
        >
          Continue with Google
        </button>

        <div className="auth-foot">
          Already have an account? <Link to="/login">Sign in</Link>
        </div>
      </div>
    </div>
  );
}
